export const generateSecurePassword = (): string => {
  const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
  const numberChars = '0123456789';
  const symbolChars = '!@#$%^&*()_+-={}[]:";\'<>,./';

  // Get one of each required character type
  const randomUpper =
    uppercaseChars[Math.floor(Math.random() * uppercaseChars.length)];
  const randomLower =
    lowercaseChars[Math.floor(Math.random() * lowercaseChars.length)];
  const randomNumber =
    numberChars[Math.floor(Math.random() * numberChars.length)];
  const randomSymbol =
    symbolChars[Math.floor(Math.random() * symbolChars.length)];

  // Create the remaining characters pool (excluding '<>/\')
  const allChars = uppercaseChars + lowercaseChars + numberChars + symbolChars;

  // Generate remaining characters
  const remainingLength = 9 - 4; // 4 is the number of required characters we already have
  let remainingChars = '';
  for (let i = 0; i < remainingLength; i++) {
    remainingChars += allChars[Math.floor(Math.random() * allChars.length)];
  }

  // Combine all parts and shuffle
  return [
    ...(randomUpper +
      randomLower +
      randomNumber +
      randomSymbol +
      remainingChars),
  ]
    .sort(() => Math.random() - 0.5)
    .join('');
};
